// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"d920893b","33":"5d78545c","92":"b9af1943","148":"5b3494aa","155":"c68a1b52","210":"d752b7b3","225":"10ad79a3","262":"3877cc35","334":"6351cd60","453":"0e9984c3","589":"7b3488a0","640":"1984a782","826":"a6998e20"}[chunkId] + ".chunk.js";
};